import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { useSelector } from 'react-redux';
import { getDropdownValues } from '../../scheduleSurgery/redux/actions';

export function useReportUsageEffect({
    myCaseResourceType,
    currentActivity,
    setShowReportPayment,
    setCurrentActivity,
    getModifiedButtonVisibilities,
    footerButtonStatuses,
    replenish,
    reportPaymentScreenName,
    submit,
    next,
    setFooterButtonStatuses,
    procedureCodeFromSummary,
    salesOrg,
    orderStatusDescription,
    t,
    setDraft,
    dispatch,
    procedurePageVisibility,
    review,
    replenishmentPageVisibilityUsage,
    procedure,
    sapPartnerId
}) {
    const { physicianDropdownZGReportUsageVisibility, accountPhysicianAPIUsage } = useSelector((state) => state.loginReducer);
    useEffectWithErrorLogging(() => {
        if (
            myCaseResourceType === 'reportPayment' &&
            currentActivity !== 'Submit'
        ) {
            setShowReportPayment(true);
            setCurrentActivity('Procedure');
            const modifiedButtonStatuses = getModifiedButtonVisibilities(
                myCaseResourceType,
                footerButtonStatuses,
                replenish,
                reportPaymentScreenName === 'Review' ? submit : next
            );
            setFooterButtonStatuses(modifiedButtonStatuses);
        } else {

            setDraft(
                orderStatusDescription != undefined &&
                    orderStatusDescription ===
                        t('orders.orderStatuses.draftNotSubmitted')
            );
            const params = {
                physicianType: 'favorites',
                isLoadAll: false,
                searchTerm: '',
                sapPartnerId
            };
            if(physicianDropdownZGReportUsageVisibility === 'VISIBLE'  && accountPhysicianAPIUsage){
                sapPartnerId && dispatch(
                    getDropdownValues({
                        dropDownName: 'physicianList',
                        value: params,
                    })
                );
            } else {
                dispatch(
                    getDropdownValues({
                    dropDownName: 'physicianList',
                    value: params,
                })
                );
            }            
        }
    }, [myCaseResourceType, orderStatusDescription]);
}
